import React, { useState } from "react";
import { OrderStatus } from "src/enums/orderStatus";
import { SelectBox } from "../selectbox/Selectbox";
import { useTranslation } from "react-i18next";
import { indexStore } from "src/store/indexStore";
import { formatDate } from "../utils/FormatDate";
import {
  Utensils,
  Package,
  Truck,
  ClipboardList,
  CreditCard,
  Wallet,
  Sofa,
  Clock,
  MapPin,
  Phone,
  Calendar,
  FileText,
  Contact2Icon,
  Tag,
} from "lucide-react";
import UAEDirhamIcon from "../utils/UAEDirhamIcon";
import OrderDetails from "./OrderDetails";
import { Button } from "../ui/button";
import { MainDialog } from "../Dialgos/MainDialog";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Card, CardContent, CardHeader } from "../ui/card";
import { Badge } from "../ui/badge";
import { userTypes } from "src/enums/usersTpes";
import Visibility from "../utils/Visibility";
function OrderRow(props) {
  const { order, setOrder } = props;
  const { UpdateOrderStatusFunction, refundOrderFunction, orderLoading, lang } =
    indexStore();
  const [status, setStatus] = useState(order.status);
  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  const [refundAmount, setRefundAmount] = useState(
    order.final_total || order.total || ""
  );
  const { t } = useTranslation();
  const per = localStorage.getItem("role");
  const canEdit = per === userTypes.ADMIN;
  const handleChangeStatus = (value) => {
    setStatus(value);
    setOrder({ ...order, status: value });
    UpdateOrderStatusFunction({ order_id: order.id, status: value });
  };

  // تحديد لون الحالة

  // تحديد أيقونة نوع الطلب
  const getOrderTypeIcon = (type) => {
    switch (type) {
      case "dine_in":
        return <Utensils className="w-8 h-8 text-gray-600" />;
      case "take_away":
        return <Package className="w-8 h-8 text-gray-600" />;
      case "delivary":
        return <Truck className="w-8 h-8 text-gray-600" />;
      default:
        return <ClipboardList className="w-8 h-8 text-gray-600" />;
    }
  };

  // تحديد أيقونة طريقة الدفع
  const getPaymentIcon = (method) => {
    switch (method) {
      case "cash":
        return <UAEDirhamIcon className="w-5 h-5 text-gray-600" />;
      case "credit":
        return <CreditCard className="w-5 h-5 text-gray-600" />;
      default:
        return <UAEDirhamIcon className="w-5 h-5 text-gray-600" />;
    }
  };

  return (
    <Card className="group hover:shadow-xl transition-all duration-300 overflow-hidden border-2 hover:border-primary/20">
      <CardHeader className="pb-3">
        <div className="flex justify-between items-start">
          <div className="flex items-center gap-4 flex-1 min-w-0">
            <div className="p-3 rounded-xl bg-gradient-to-br from-primary/10 to-primary/5 shrink-0">
              {getOrderTypeIcon(order.type)}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-xl font-bold text-foreground mb-1">
                {t("gloabl.order")} #{order.order_number}
              </h3>
              <p className="text-sm text-muted-foreground capitalize">
                {t(`orderType.${order.type}`)}
              </p>
            </div>
          </div>
          <Badge
            variant="outline"
            className={`shrink-0 ${getStatusColor(status)}`}
          >
            {t(`orderStatus.${status}`)}
          </Badge>
        </div>
      </CardHeader>

      <CardContent className="p-6 pt-4">
        {/* Order Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
          {/* Basic Info */}
          <div className="space-y-3">
            <div className="p-4 bg-gradient-to-br from-green-50 to-green-100/50 dark:from-green-950/30 dark:to-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
              <div className="flex items-center gap-2 mb-2">
                <UAEDirhamIcon className="w-5 h-5 text-green-600" />
                <p className="text-sm font-medium text-muted-foreground">
                  {t("gloabl.final_total")}
                </p>
              </div>
              <p className="font-bold text-2xl text-green-600">
                {Number(order.final_total).toFixed(2)}
              </p>
            </div>
            <div className="p-4 bg-gradient-to-br from-blue-50 to-blue-100/50 dark:from-blue-950/30 dark:to-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
              <div className="flex items-center gap-2 mb-2">
                <UAEDirhamIcon className="w-5 h-5 text-blue-600" />
                <p className="text-sm font-medium text-muted-foreground">
                  {t("gloabl.sub_Total")}
                </p>
              </div>
              <p className="font-bold text-xl text-blue-600">
                {Number(order.total).toFixed(2)}
              </p>
            </div>

            <div className="p-3 bg-muted/50 rounded-lg border">
              <div className="flex items-center gap-2">
                <span className="text-muted-foreground">
                  {getPaymentIcon(order.payment_method)}
                </span>
                <div>
                  <p className="text-xs text-muted-foreground">
                    {t("gloabl.payment_method")}
                  </p>
                  <p className="font-medium text-sm capitalize">
                    {t(`paymentMethod.${order.payment_method}`)}
                  </p>
                </div>
              </div>
            </div>

            {order.wallet_amount > 0 && (
              <div className="p-3 bg-muted/50 rounded-lg border">
                <div className="flex items-center gap-2">
                  <Wallet className="w-4 h-4 text-muted-foreground" />
                  <div>
                    <p className="text-xs text-muted-foreground">
                      {t("gloabl.wallet_amount")}
                    </p>
                    <p className="font-medium text-sm text-blue-600 flex items-center gap-1">
                      <UAEDirhamIcon className="w-3 h-3" />
                      {Number(order.wallet_amount).toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {order.coupon && (
              <div className="p-3 bg-gradient-to-br from-purple-50 to-purple-100/50 dark:from-purple-950/30 dark:to-purple-900/20 rounded-lg border border-purple-200 dark:border-purple-800">
                <div className="flex items-center gap-2">
                  <Tag className="w-4 h-4 text-purple-600" />
                  <div>
                    <p className="text-xs text-muted-foreground">
                      {t("gloabl.copun") || "Coupon"}
                    </p>
                    <p className="font-medium text-sm text-purple-600">
                      {order.coupon.code} - {order.coupon.value}
                      {order.coupon.type === "percentage" ? "%" : ""} (
                      {order.coupon.type === "percentage"
                        ? t("gloabl.percentage") || "Percentage"
                        : t("gloabl.fixed") || "Fixed"}
                      )
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Order Type Specific Info */}
          <div className="space-y-3">
            {order.type === "dine_in" && order.table_id && (
              <div className="p-3 bg-muted/50 rounded-lg border">
                <div className="flex items-center gap-2">
                  <Sofa className="w-4 h-4 text-muted-foreground" />
                  <div>
                    <p className="text-xs text-muted-foreground">
                      {t("gloabl.table_number")}
                    </p>
                    <p className="font-medium text-sm">{order.table_id}</p>
                  </div>
                </div>
              </div>
            )}

            {order.type === "take_away" && order.time_takeaway && (
              <div className="p-3 bg-muted/50 rounded-lg border">
                <div className="flex items-center gap-2">
                  <Clock className="w-4 h-4 text-muted-foreground" />
                  <div>
                    <p className="text-xs text-muted-foreground">
                      {t("gloabl.time_takeaway")}
                    </p>
                    <p className="font-medium text-sm">
                      {formatDate(new Date(order.time_takeaway))}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {order.type === "delivary" && order.delivery_address && (
              <div className="p-3 bg-muted/50 rounded-lg border">
                <div className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 text-muted-foreground mt-1" />
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-muted-foreground mb-1">
                      {t("gloabl.delivery_address")}
                    </p>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://www.google.com/maps?q=${order.delivery_address?.latitude},${order.delivery_address?.longitude}`}
                      className="font-medium text-sm leading-relaxed text-primary hover:underline"
                    >
                      {order.delivery_address.address_line_1}
                      - {order.delivery_address.address_line_2}
                    </a>
                  </div>
                </div>
              </div>
            )}

            {order.delivary_fees > 0 && (
              <div className="p-3 bg-gradient-to-br from-orange-50 to-orange-100/50 dark:from-orange-950/30 dark:to-orange-900/20 rounded-lg border border-orange-200 dark:border-orange-800">
                <div className="flex items-center gap-2">
                  <Truck className="w-4 h-4 text-orange-600" />
                  <div>
                    <p className="text-xs text-muted-foreground">
                      {t("gloabl.delivery_fees")}
                    </p>
                    <p className="flex items-center gap-1 font-medium text-sm text-orange-600">
                      <UAEDirhamIcon className="w-3 h-3" />
                      {Number(order.delivary_fees).toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Contact & Time Info */}
          <div className="space-y-3">
            {order.customer && (
              <div className="p-3 bg-muted/50 rounded-lg border">
                <div className="flex items-center gap-2">
                  <Phone className="w-4 h-4 text-muted-foreground" />
                  <div>
                    <p className="text-xs text-muted-foreground">
                      {t("gloabl.phone")}
                    </p>
                    <p className="font-medium text-sm" dir="ltr">
                      {order.customer.phone || "_"}
                    </p>
                  </div>
                </div>
              </div>
            )}
            {order.customer && (
              <div className="p-3 bg-muted/50 rounded-lg border">
                <div className="flex items-center gap-2">
                  <Contact2Icon className="w-4 h-4 text-muted-foreground" />
                  <div>
                    <p className="text-xs text-muted-foreground">
                      {t("gloabl.customer")}
                    </p>
                    <p className="font-medium text-sm">
                      {order.customer.name_en || "_"}
                    </p>
                  </div>
                </div>
              </div>
            )}

            <div className="p-3 bg-muted/50 rounded-lg border">
              <div className="flex items-center gap-2">
                <Calendar className="w-4 h-4 text-muted-foreground" />
                <div>
                  <p className="text-xs text-muted-foreground">
                    {t("gloabl.created_at")}
                  </p>
                  <p className="font-medium text-sm">
                    {formatDate(new Date(order.created_at))}
                  </p>
                </div>
              </div>
            </div>

            {order.note && (
              <div className="p-3 bg-muted/50 rounded-lg border">
                <div className="flex items-start gap-2">
                  <FileText className="w-4 h-4 text-muted-foreground mt-1" />
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-muted-foreground mb-1">
                      {t("gloabl.note")}
                    </p>
                    <p className="font-medium text-sm leading-relaxed">
                      {order.note}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="mb-4">
          <OrderDetails order_id={order.id} />
        </div>

        <div className="h-px bg-border my-4" />

        {/* Status Update Section */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 w-full justify-between">
          <div>
            <Visibility visible={canEdit}>
              <MainDialog
                open={refundDialogOpen}
                onOpenChange={setRefundDialogOpen}
                trigger={
                  <Button
                    disabled={order.refund}
                    variant="destructive"
                    size="sm"
                    onClick={() => {
                      setRefundAmount(order.final_total || order.total || "");
                      setRefundDialogOpen(true);
                    }}
                  >
                    {t("gloabl.refund")}
                  </Button>
                }
                title={t("gloabl.refund")}
                description={t("gloabl.order") + " #" + order.order_number}
                footer={
                  <div className="flex gap-2 justify-end">
                    <Button
                      variant="outline"
                      onClick={() => {
                        setRefundDialogOpen(false);
                        setRefundAmount(order.final_total || order.total || "");
                      }}
                    >
                      {t("gloabl.cancel")}
                    </Button>
                    <Button
                      variant="destructive"
                      onClick={async () => {
                        if (refundAmount && parseFloat(refundAmount) > 0) {
                          const result = await refundOrderFunction(
                            order.id,
                            parseFloat(refundAmount)
                          );
                          if (result?.success) {
                            setRefundDialogOpen(false);
                            setRefundAmount(
                              order.final_total || order.total || ""
                            );
                          }
                        }
                      }}
                      disabled={
                        orderLoading ||
                        !refundAmount ||
                        parseFloat(refundAmount) <= 0
                      }
                    >
                      {orderLoading
                        ? t("gloabl.processing")
                        : t("gloabl.confirm")}
                    </Button>
                  </div>
                }
              >
                <div className="space-y-4 py-4">
                  <div className="space-y-2">
                    <Label htmlFor="refund-amount">
                      {t("gloabl.refund_amount")}
                    </Label>
                    <div className="relative">
                      <Input
                        id="refund-amount"
                        type="number"
                        min="0"
                        step="0.01"
                        value={refundAmount}
                        onChange={(e) => setRefundAmount(e.target.value)}
                        placeholder={t("gloabl.refund_amount")}
                        className="w-full pr-8"
                      />
                    </div>
                    <p className="text-sm  flex items-center gap-2">
                      {t("gloabl.final_total")}:{" "}
                      <div className="flex items-center gap-1">
                        <UAEDirhamIcon className="w-4 h-4 " />
                        <span className="text-sm ">
                          {order.final_total || order.total}
                        </span>
                      </div>
                    </p>
                  </div>
                </div>
              </MainDialog>
            </Visibility>
          </div>
          <div className="flex items-center justify-between flex-1">
            <span className="text-sm font-medium text-muted-foreground whitespace-nowrap">
              {t("gloabl.update")} {t("gloabl.status")}:
            </span>
            <SelectBox
              placeholder={t("gloabl.status")}
              valueKey="value"
              data={[
                { label: t("orderStatus.pending"), value: OrderStatus.pending },
                {
                  label: t("orderStatus.processing"),
                  value: OrderStatus.processing,
                },
                // إظهار خيار delivarying فقط إذا كانت الحالة الحالية هي delivarying
                ...(order.type === "delivary"
                  ? [
                      {
                        label: t("orderStatus.delivarying"),
                        value: OrderStatus.delivarying,
                      },
                    ]
                  : []),
                {
                  label: t("orderStatus.completed"),
                  value: OrderStatus.completed,
                },
                {
                  label: t("orderStatus.canseled"),
                  value: OrderStatus.canseled,
                },
              ]}
              onValueChange={handleChangeStatus}
              label="label"
              value={status}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default OrderRow;
export const getStatusColor = (status) => {
  switch (status) {
    case OrderStatus.pending:
      return "bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900 dark:text-yellow-200";
    case OrderStatus.processing:
      return "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900 dark:text-blue-200";
    case OrderStatus.delivarying:
      return "bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-900 dark:text-purple-200";
    case OrderStatus.completed:
      return "bg-green-100 text-green-800 border-green-200 dark:bg-green-900 dark:text-green-200";
    case OrderStatus.canseled:
      return "bg-red-100 text-red-800 border-red-200 dark:bg-red-900 dark:text-red-200";
    default:
      return "bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-800 dark:text-gray-200";
  }
};
